import { defineStore } from "pinia";

// Estado de contenido seleccionado en Home. No se persiste porque son dialogs
// y datos temporales que deben reiniciarse al navegar o recargar.
export const useHomeContentStore = defineStore("homeContent", {
  state: () => ({
    undanews: {},
    undanita: {},
    benefit: {},
    showDialogUndanita: false,
    showDialogUndanews: false,
    showDialogBenefit: false,
  }),
  getters: {
    getUndanita: (state) => state.undanita,
    getUndanews: (state) => state.undanews,
  },
  actions: {
    setBenefit(obj) {
      this.benefit = obj;
    },
    setShowDialogBenefit(val) {
      this.showDialogBenefit = val;
    },
    setUndanews(obj) {
      this.undanews = obj;
    },
    setUndanita(obj) {
      this.undanita = obj;
    },
    setShowDialogUndanews(val) {
      this.showDialogUndanews = val;
    },
    setShowDialogUndanita(val) {
      this.showDialogUndanita = val;
    },
  },
});
